import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { Box, Heading, Center, Text } from '@chakra-ui/react';

const metricDetails = {
    pm25: { unit: 'µg/m³', name: 'PM2.5' },
    pm10: { unit: 'µg/m³', name: 'PM10' },
    tsp: { unit: 'µg/m³', name: 'TSP' },
    noise: { unit: 'dB', name: 'Noise' },
};

export default function HistoryChart({ data, metric, type, dataType, showAvg, showMin, showMax }) {
  const { chartOptions, chartSeries } = useMemo(() => {
    const details = metricDetails[metric] || { unit: '', name: metric };
    const series = [];

    // --- REQ 1: ปรับ Logic การสร้าง Series ---
    if (dataType === 'raw') {
      series.push({
        name: 'Value',
        data: data.map(d => d.data?.[metric]?.toFixed(2) ?? null),
      });
    } else { // Hourly or Daily
      const metricUpper = metric.charAt(0).toUpperCase() + metric.slice(1);
      // เรียงลำดับ Max -> Avg -> Min เพื่อให้ Area Chart แสดงผลถูกต้อง
      if (showMax) series.push({ name: 'Max', data: data.map(d => d.data?.[`max${metricUpper}`]?.toFixed(1) || null) });
      if (showAvg) series.push({ name: 'Average', data: data.map(d => d.data?.[`avg${metricUpper}`]?.toFixed(1) || null) });
      if (showMin) series.push({ name: 'Min', data: data.map(d => d.data?.[`min${metricUpper}`]?.toFixed(1) || null) });
    }

    const options = {
      // REQ 2: เพิ่มสีและปรับสไตล์
      colors: ['#f1c40f', '#3498db', '#2ecc71'], // Yellow(Max), Blue(Avg), Green(Min)
      chart: { type, height: 400, toolbar: { show: true } },
      xaxis: {
        type: 'datetime',
        categories: data.map(d => new Date(d.timestamp || d.hourStart || d.dayStart).toISOString()),
      },
      yaxis: { title: { text: `${details.name} (${details.unit})` } },
      title: { text: `${dataType.charAt(0).toUpperCase() + dataType.slice(1)} Data for ${details.name}` },
      stroke: { 
        curve: 'smooth',
        width: type === 'line' ? 2 : 0 // REQ 2: ทำให้เส้นบางลง และเอาขอบ Bar ออก
      },
      fill: {
        type: type === 'bar' ? 'gradient' : 'solid', // REQ 2: ทำให้ Bar เป็น Gradient
        opacity: type === 'area' ? [0.3, 0.5, 0.7] : 1,
      },
      tooltip: { x: { format: 'dd MMM yyyy HH:mm' } },
      dataLabels: { enabled: false },
    };

    return { chartOptions: options, chartSeries: series };
  }, [data, metric, type, dataType, showAvg, showMin, showMax]);

  if (!data || data.length === 0) {
    return <Center h="400px"><Text>No data available for the selected criteria.</Text></Center>;
  }

  return (
    <Box><Chart options={chartOptions} series={chartSeries} type={type} height={400} /></Box>
  );
}